import Stars from 'components/Stars'
import React from 'react'
import {
  ItemImage,
  ItemImageContainer,
  ItemName,
  ItemPrice,
  ProductItemContainer,
  SpecialTag,
  SpecialTagContainer,
  TopCircle,
} from './ProductItem.style'
import { BrowserView, MobileAndTabletView } from '../../DeviceDetect'
import Percent3 from '../../Icons/Percent3'
import Flash from '../../Icons/Flash'
import Star2 from '../../Icons/Star2'
import Gift from '../../Icons/Gift'
import Megaphone from 'components/Icons/Megaphone'

const ProductItem = props => {
  const item = props.item || {}
  const { onlyPictureandPrice } = props
  const { onlyPicture } = props

  return (
    <ProductItemContainer
      className="product-item"
      istop={item.top}
      nohover={props.nohover}
      itemScope
      itemProp="itemListElement"
      itemType="https://schema.org/Product"
      to={item.slug ? `/product/${item.slug}` : item.url ? item.url : '/'}
    >
      <link
        itemProp="url"
        href={item.slug ? `/product/${item.slug}` : item.url ? item.url : '/'}
      />
      {item.top && <TopCircle>TOP</TopCircle>}

      <ItemImageContainer onlyPicture={onlyPicture}>
        <BrowserView>
          <ItemImage className={item.image2 ? 'hovered' : ''}>
            <img
              itemProp="image"
              className="object-contain"
              src={item.image}
              loading="lazy"
              alt=""
            />
            {item.image2 ? (
              <img
                className="second-image lazyload"
                data-src={item.image2}
                alt={item.name}
              />
            ) : null}
          </ItemImage>
        </BrowserView>
        <MobileAndTabletView>
          <ItemImage>
            <img
              itemProp="image"
              className="object-contain"
              src={item.image}
              loading="lazy"
              alt=""
            />
          </ItemImage>
        </MobileAndTabletView>
      </ItemImageContainer>
      {!onlyPicture ? (
        <>
          {!onlyPictureandPrice ? (
            <SpecialTagContainer>
              {typeof icons[item.icon] !== 'undefined'
                ? icons[item.icon]
                : null}
            </SpecialTagContainer>
          ) : null}

          <ItemPrice
            itemProp="offers"
            itemScope
            itemType="https://schema.org/Offer"
          >
            {item.price && !item.old_price ? (
              <p
                style={{ color: 'black' }}
                itemProp="price"
                content={item.price}
              >
                {item.price}
                <span
                  style={{ color: 'black' }}
                  className="price-icon"
                  itemProp="priceCurrency"
                  content="GEL"
                >
                  ₾
                </span>
              </p>
            ) : item.price ? (
              <p itemProp="price" content={item.price}>
                {item.price}
                <span
                  className="price-icon"
                  itemProp="priceCurrency"
                  content="GEL"
                >
                  ₾
                </span>
              </p>
            ) : (
              <p className="out-of-stock">არ არის მარაგში</p>
            )}
            {item.old_price && item.price ? (
              <span>{item.old_price}₾</span>
            ) : null}
          </ItemPrice>
          {!onlyPictureandPrice ? (
            <div className="stars-and-name">
              <Stars className="stars" amount={Math.round(item.rating / 2)} />
              <ItemName itemProp="name" color="black2">
                {item.name}
              </ItemName>
            </div>
          ) : null}
        </>
      ) : null}
    </ProductItemContainer>
  )
}

export default ProductItem

const icons = {
  sale: (
    <SpecialTag type="sale">
      <Percent3 color="white" size="16px" />
      ფასდაკლება
    </SpecialTag>
  ),
  fast: (
    <SpecialTag type="fast">
      <Flash color="white" width="12px" height="16px" />
      სწრაფი მიტანა
    </SpecialTag>
  ),
  top: (
    <SpecialTag type="top">
      <Star2 color="white" size="16px" />
      პოპულარული
    </SpecialTag>
  ),
  gift: (
    <SpecialTag type="gift">
      <Gift color="white" size="16px" />
      საჩუქარი
    </SpecialTag>
  ),
  last: (
    <SpecialTag type="last">
      <Megaphone color="white" size="16px" />
      ბოლო ერთეული
    </SpecialTag>
  ),
}
